import React, { useState } from 'react';
import './CheckmarkWithHover.css';
import { FaCheck } from 'react-icons/fa6';
import { ImCross } from "react-icons/im";

const CheckmarkWithHover = ({status, dateStr }) => {

    const [isHovered, setIsHovered] = useState(false);

    const monthName = (dateStr) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const dateObj = new Date(dateStr);
        const monthNumber = dateObj.getMonth();
        return monthNames[monthNumber]
    }

    const statusMapping = {
        '1': { colorClass: 'green-check', message: 'Received' },
        '2': { colorClass: 'amber-check', message: '2nd NACH Clear' },
        '3': { colorClass: 'amber-check', message: '3rd NACH Clear' },
        '4': { colorClass: 'checkmarkothers', message: 'Recovered' },
        '6': { colorClass: 'checkmarkothers', message: 'Adhoc clear' },
        '7': { colorClass: 'checkmarkothers', message: 'Waived off' },
        '5': { colorClass: 'red-check', message: 'Pending' }
    };

    const defaultStatus = { colorClass: 'red-check', message: 'Pending' };

    const { colorClass, message } = statusMapping[status] || defaultStatus;
  
    return (
        <>
            <div
                className="checkmark-container"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {['1', '2', '3', '4', '6', '7'].includes(status)  ? (
                    <FaCheck className={`${colorClass}`} />
                ) : (
                    <ImCross className={`${colorClass}`} />
                )}

                {isHovered && (
                    <div className={`hover-label-${colorClass.split('-')[0]}`}>
                        {`${monthName(dateStr)} : ${message}`}
                    </div>
                )}
            </div>
        </>
    );
};

export default CheckmarkWithHover;